export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/auth/endorsement',
    name: 'endorsement',
    component: () => import('@/views/dashboard/endorsement.vue'),
  },
  {
    path: '/auth/card',
    name: 'card',
    component: () => import('@/views/dashboard/endorsement.vue'),
  },
  {
    path: '/auth/postpone',
    name: 'postpone',
    component: () => import('@/views/dashboard/endorsement.vue'),
  },
]
